/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, {  Component } from 'react';
import {
    string, object, func, oneOfType, shape, elementType, number,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import ImageEditorControlView from './ImageEditorControlView';

const styles = () => ({
    canvas: {
        width: '100%',
        height: '100%',
    },
});

class ImageEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            showEditor: true,
        };
    }

    componentDidMount() {
    // updates image into canvas at the time of render
        const isFirstLoad = true;
        this.renderCanvasImage(isFirstLoad);
    }

    componentDidUpdate() {
    // updates images after manipulation
        const isFirstLoad = false;
        this.renderCanvasImage(isFirstLoad);
    }

    handleShowEditor = (val) => {
    // handles image edit editor
        this.setState({ showEditor: val });
    }

    renderCanvasImage = (isFirstLoad) => {
        const {
            x, y, width, height,
        } = this.state;
        const {
            image64, imagePreviewCanvasRef, imgHeight, imgWidth,
        } = this.props;
        const canvas = imagePreviewCanvasRef.current;
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        const image = new Image();
        image.src = image64;
        image.onload = () => {
            if (isFirstLoad) {
                this.setState({ height: image.height, width: (image.height * (imgWidth / imgHeight)) });
            }
            ctx.drawImage(
                image,
                x,
                y,
                width,
                height,
                0,
                0,
                width,
                height,
            );
        };
    };

    setX = (val) => {
        this.setState({ x: val });
    }

    setY = (val) => {
        this.setState({ y: val });
    }

    setWidth = (val) => {
        const { width } = this.state;
        const { imgHeight, imgWidth } = this.props;
        this.setState({ width: width + val });
        this.setState({ height: ((width + val) * (imgHeight / imgWidth)) });
    }

    handleImageDoneOperation  = () => {
        this.handleShowEditor(false);
    };

    render() {
        const {
            x, y, width, showEditor,
        } = this.state;
        const {
            classes, imagePreviewCanvasRef, setImage,
        } = this.props;

        return (
            <>
                <canvas ref={imagePreviewCanvasRef} className={classes.canvas} />
                {showEditor
                    ? (
                        <ImageEditorControlView
                            x={x}
                            y={y}
                            width={width}
                            setX={this.setX}
                            setY={this.setY}
                            handleShowEditor={this.handleImageDoneOperation}
                            setImage={setImage}
                            setWidth={this.setWidth}
                        />
                    )
                    : null}
            </>
        );
    }
}
ImageEditor.propTypes = {
    classes: object.isRequired,
    image64: string.isRequired,
    setImage: func.isRequired,
    imagePreviewCanvasRef: oneOfType([
        func,
        shape({ current: elementType }),
    ]).isRequired,
    imgWidth: number.isRequired,
    imgHeight: number.isRequired,

};
export default withStyles(styles)(ImageEditor);
